import { json } from "@sveltejs/kit";
import { a as sendBugReport } from "../../../../chunks/mailer.js";
const POST = async ({ request }) => {
  const { title, description, machine } = await request.json();
  await sendBugReport(title, description, machine);
  return json({ success: true });
};
export {
  POST
};
